<template lang="pug">
  include /mixins
  +b.review-view
    ui-accordion(
      :init='false'
      :id='review.id'
    )
      template(#default='{ activeState, toggleActive, style }')
        +b.review
          +e.top
            +e.author
              +b.review-author.--space_none
                //- +e.img-wrap
                //-   +e.img.IMG(
                //-     :src='review.props.user && review.props.user.props.img && review.props.user.props.img.catalog_preview ? review.props.user.props.img.catalog_preview : "/static/img/rebranding/non.png"'
                //-   )
                +e.name.P {{ review.props.name }}
              +e.date.P {{ review.props.created_at }}
            +e.rate(:class="{ 'is-spaced': !showMedia }")
              pretty-stars(
                :rating='review.props.rate'
                :read-only='true'
              )
          +e.content
            template(v-if='review.props.original_lang && review.props.original_lang !== lang')
              +e.body
                +b.t-content
                  p(v-html='showTrans ? review.props.comment : review.props.translation_comment')
              +e.translation-actions
                +b.g-row.--space_lg.--appearance_spaced
                  +b.g-cell.g-cols
                    +b.tt-link.--styling_3(
                      @click='showTrans = !showTrans'
                    ) {{ showTrans ? _('Показать перевод') : _('Показать оригинал') }}
                  +b.g-cell.g-cols(v-if='!showTrans')
                    +b.ds-caption--size_xs.--size_sm-xl.--color_text-8.--medium.P {{_('Переведено автоматически')}}
            +e.body(v-else)
              +b.t-content
                p(v-html='review.props.comment')
            +e.media(v-if='showMedia && hasMedia')
              +b.slider-box.--free.relative
                +b.category-swipe-wrapper.--variant_common.fake-slider
                  +e.cell.--variant_12(
                    v-for='(photo, i) in review.props.photos',
                  )
                    light-box-v2(
                      :key="`photo${photo.id}`"
                      :source='[photo.props.img]'
                    )
                      template(#default='{ show }')
                        +b.review-media(@click='show(i)')
                          +e.PICTURE.image-wrapper
                            +e.image.IMG(:src='photo.props.img')
                          +e.IMG.icon(
                            :src="'/static/img/zoom-white.svg'"
                          )
                  +e.cell.--variant_12(
                    v-for='(video, i) in review.props.videos',
                    :key="`video${video.id}`"
                  )
                    ui-youtube-view(:url='video.props.url')
                      template(#default='{ play, preview }')
                        +b.review-media(@click='play')
                          +e.PICTURE.image-wrapper
                            +e.image.IMG(:src='preview')
                          +e.IMG.play-icon(
                            :src="'/static/img/youtube.svg'"
                          )
                +b.t-controls.--space_top.--variant_review-media.snap-controls(
                  :data-count="review.props.photos.length + review.props.videos.length"
                )
                  +e.item.is-disabled(data-snap-slider-goto="right")
                    +b.mdi.mdi-chevron-left
                  +e.item(data-snap-slider-goto="left")
                    +b.mdi.mdi-chevron-right
          +e.footer
            +e.bottom(
              :class="{ 'has-childs': !!review.props.children.length }"
            )
              +b.tt-link(
                @click.prevent='toggleActive'
                v-if='review.props.children.length'
              )
                +e.text.P.ds-caption--color_accent.--size_xs.--size_sm-xl.--medium {{ activeState ? _('Скрыть ответы') : _('Читать ответы') }} ({{ review.props.children.length }})
                  +e.icon.mdi(:class='style.icon')
              +b.tt-link--variant_start.BUTTON(
                @click.prevent='replier ? replier(review) : $emit("reply", review.id, review.id, review.props.name)'
              )
                +e.icon.icon-right
                +e.text.P.ds-caption--color_accent.--size_xs.--size_sm-xl.--medium {{ _('ответить') }}
            +e.childs-list(v-if='activeState')
              +e.child(
                v-for='child in review.props.children'
              )
                child-preview(
                  :child='child'
                  :replier='replier'
                  :showMedia='showMedia'
                )
</template>

<script>
import ChildPreview from './ChildPreview.vue'

export default {
  name: 'ReviewDetail',

  components: {
    ChildPreview,
  },

  props: {
    review: {
      type: Object,
      default: () => {},
    },
    replier: {
      type: Function,
    },
    showMedia: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    hasMedia() {
      const hasPhotos = !!this.review.props.photos.length
      const hasVideos = !!this.review.props.videos.length

      return hasPhotos || hasVideos
    },
  },

  data() {
    return {
      lang: window.language,
      showTrans: false,
    }
  },
}
</script>
